module.exports = __webpack_public_path__ + "static/media/img_slideshow2vr.6813c3a0.jpg";